import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from '../app/endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const offerApi = createApi({
  reducerPath: 'offerApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['offer'],
  endpoints: (builder) => ({
    getAllOfferDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.offerDetailController.getAllOfferDetail,
          method: 'POST',
          headers: body.token ? { Authorization: `Bearer ${body.token}` }:{},
          body: body.payload,
        };
      },
    }),
  })
});

export const {
  useGetAllOfferDetailMutation,
} = offerApi;
